/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The role a user has within a channel.
 */
export type ParticipantRole =
  (typeof ParticipantRole)[keyof typeof ParticipantRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParticipantRole = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
} as const;
